import React from 'react';
import './companies.css';
import C2wCompanyCard from '../../../common/C2wHome/companies/companyCard';
import companies from './companies.json'
import { Helmet } from 'react-helmet';
function C2wCompanies() {
    
    /**
 * @constant renderedCompanyCards
 * @author Vishal Lohbande
 *
 * Description:
 * - Renders a list of `C2wCompanyCard` components by mapping over an array of company objects.
 * - Each object (`obj`) is passed as a prop to the `C2wCompanyCard` component.
 *
 * Usage:
 * - Used to display company-related cards, typically in a placement or partnership section.
 *
 * Notes:
 * - Consider adding a unique `key` prop to each component instance to help React identify items efficiently during re-rendering.
 * - Ensure the source array is defined and not empty before rendering to avoid errors.
 */
    const renderedCompaniesCards = companies?.companyLogos?.map(( obj ) => {
        return <C2wCompanyCard obj={obj} />
    })

    return (
        <div className='C2wCompanies_ctn'>
            <Helmet>
                    {/* 
                    Purpose: Defines the page title displayed in search results and browser tabs. 
                             It’s one of the most important SEO elements. 
                    */}
                    <title>{`180+ MNC Companies`}</title>  
            
                    {/* 
                    Purpose: Provides a brief summary of the page content in search results. 
                             While not a direct ranking factor, it influences CTR. 
                    */}
                    <meta name="description" content="Students Placed in 180+ MNC Companies" />
                    
                    {/* Purpose: Controls indexing and link-following behavior. */}
                    <meta name="robots" content="index, follow" />
                    
                  </Helmet>
            <div className='C2wCompanies_ctn_scroller'>
            <div className='C2wCompanies_ctn_holder'>
                <div className='C2wCompaniesHeading_ctn_hld'>
                    <div className='C2wComapniesHeading_ctn'>
                        {'Placed in '}
                        <span className='C2wPlacementsHeadingSpan'>{' 180+ '}</span>
                        {'MNC Companies'}
                    </div>
                </div>
                <div className='C2wCompanies_ctn_companiesCards_htder'>
                    {renderedCompaniesCards}
                </div>
            </div>
        </div>
        </div>
    )
}

export default C2wCompanies;